import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-expand-item',
  templateUrl: './expand-item.component.html',
  styleUrls: ['./expand-item.component.scss'],
})
export class ExpandItemComponent implements OnInit {
  state: string = 'closed';
  @Output() onToggle: EventEmitter<any> = new EventEmitter();
  @Input() opened:boolean=false;
  @Input() data:any;
  @Input() invalid:boolean=false;
  @ViewChild("expander", { read: ElementRef }) expander: ElementRef;
  @ViewChild("expandable", { read: ElementRef }) expandable: ElementRef;

  constructor() { }

  ngOnInit() { }
  computeChevron(state: string) {
    return state == 'closed' ? 'chevron-down' : 'chevron-up';
  }
  computeClass(state: string,invalid:boolean) {
    return state == 'closed' ? `closed ion-no-padding ${invalid ? 'invalid' : ''}` : `opened ion-no-padding ${invalid ? 'invalid' : ''}`;
  }
  close(silent = false) {
    const expander = this.expander.nativeElement;
    expander.classList.remove('opened');
    expander.classList.add('closed');
    this.state = 'closed';
    this.opened = false;
    if (silent !== true) {
      this.onToggle.emit({ state: this.state, instance: this })
    }
  }
  open(silent = false) {
    const expander = this.expander.nativeElement;
    expander.classList.add('opened');
    expander.classList.remove('closed');
    this.state = 'opened';
    this.opened = true;
    if (silent !== true) {
      this.onToggle.emit({ state: this.state, instance: this })
    }
  }
  toggle() {
    const expander = this.expander.nativeElement;
    if (expander.classList.contains('opened')) {
      this.close(true);
    } else {
      this.open(true);
    }
    this.onToggle.emit({ state: this.state, instance: this });
  }
}
